module.exports = __webpack_public_path__ + "assets/indo-flag.svg";